import { render } from "./AuditsPanel.vue?vue&type=template&id=aa9a5e14&scoped=true"
import script from "./AuditsPanel.vue?vue&type=script&lang=js"
export * from "./AuditsPanel.vue?vue&type=script&lang=js"

import "./AuditsPanel.vue?vue&type=style&index=0&id=aa9a5e14&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa9a5e14"]])

export default __exports__